export default "__VITE_ASSET__CtaA83vo__"